export function isExamItemVisible (item) {
  return !!item && item.hiddenByDisabilityExtremity !== true
}

export function getVisibleExamItems (items) {
  if (!Array.isArray(items)) return []

  return items.filter(isExamItemVisible)
}

export function getIndexedVisibleExamItems (items) {
  if (!Array.isArray(items)) return []

  return items.reduce((visibleItems, item, index) => {
    if (isExamItemVisible(item)) {
      visibleItems.push({ item, index })
    }

    return visibleItems
  }, [])
}
